import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M10 13h11v-2a3 3 0 0 0 -3 -3h-8v5z","key":"svg-1"}],["path",{"d":"M3 16h18","key":"svg-2"}]]

const IconBedFlat = createReactComponent('outline', 'bed-flat', 'BedFlat', __iconNode);

export default IconBedFlat;